export const ACTION = {
  SAVE_SIP: 'SAVE_SIP',
};

